// Site content for the marketing pages. Every string here is either carried
// over from the v1 site or written for New Age Services specifically.

export const CONTACT = {
  email: "contact@newageservices.in",
  hours: "Monday-Saturday : 10:00 AM - 7:00 PM",
  offices: ["USA", "CANADA", "India"],
  linkedin: "https://www.linkedin.com/company/new-age-services-india/",
  tagline: "Transforming Challenges Into Tech Solutions",
};

export const coreValues = [
  {
    title: "Customer-Centric Approach",
    body: "We prioritize our clients' needs, tailoring solutions to meet their unique challenges.",
  },
  {
    title: "Integrity",
    body: "We maintain transparency and honesty in all our dealings, fostering trust and reliability.",
  },
  {
    title: "Innovation",
    body: "We embrace cutting-edge technologies to deliver forward-thinking solutions that drive business success.",
  },
  {
    title: "Collaboration",
    body: "We believe in working closely with our clients, forming partnerships that promote mutual growth.",
  },
  {
    title: "Trust",
    body: "We build strong relationships based on trust, ensuring our clients feel confident in our expertise and support.",
  },
  {
    title: "Support",
    body: "We are dedicated to providing exceptional support, assisting our clients every step of the way to achieve their goals.",
  },
  {
    title: "Ethics",
    body: "We adhere to the highest ethical standards in all our business practices, ensuring fairness and respect.",
  },
  {
    title: "Commitment",
    body: "We are committed to the success of our clients, consistently going above and beyond to help them achieve their objectives.",
  },
];

export const engagementSteps = [
  {
    title: "Understanding Client Needs",
    body: "We start by learning how the business actually runs before proposing anything.",
    image: "/Understanding Client Needs.jpg",
  },
  {
    title: "Tailored Solutions",
    body: "A design built for your estate and budget — not a catalogue item.",
    image: "/Tailored Solutions.jpg",
  },
  {
    title: "Implementation & Support",
    body: "Delivery, cutover and day-two support handled by the same team.",
    image: "/Implementation & Support.jpg",
  },
  {
    title: "Continuous Improvements",
    body: "Reviewed on a regular cycle so the estate keeps pace with the business.",
    image: "/Continuous Improvements.jpg",
  },
];

// Partner logos live in public/Partners/
export const partnerLogos = Array.from(
  { length: 13 },
  (_, i) => `/Partners/${i + 2}.png`
);

export const leaders = [
  {
    name: "Manish Kumar",
    role: "Business Head",
    image: "/Founder.jpg",
    linkedin: "https://www.linkedin.com/in/manish-kumar-1796835b/",
    body: "Owns commercials, partner relationships and the client relationship end to end.",
  },
  {
    name: "Ranjan Kumar",
    role: "VP — Information Technology",
    image: "/Ops_IT.jpg",
    linkedin: "https://www.linkedin.com/in/ranjankumar188/",
    body: "Owns delivery, operations and the technical standard every engagement is held to.",
  },
];

export const practices = [
  {
    id: "ITConsulting",
    title: "IT Consulting",
    body: "Our IT consulting services help businesses identify areas for improvement and develop strategic technology plans. We assess current systems, recommend best practices, and align technology with business goals to enhance efficiency and performance.",
  },
  {
    id: "ConnectivitySolutions",
    title: "Connectivity",
    body: "Includes services that help businesses connect to the internet and optimize their networks: Broadband, Internet Leased Line, MPLS and SD-WAN.",
  },
  {
    id: "CommunicationSolutions",
    title: "Communication",
    body: "This includes services focused on voice communication, telephony, and conferencing: PRI, SIP Trunk, Toll-Free and Video Conferencing.",
  },
  {
    id: "SecuritySolutions",
    title: "Security Solutions",
    body: "The security services are designed to protect your business from evolving cyber threats — antivirus, firewall, surveillance, biometrics and VDI.",
  },
  {
    id: "DataStorage",
    title: "Data Storage and Infrastructure",
    body: "This category encompasses the storage and infrastructure management services that businesses use for data and IT operations.",
  },
];

// Illustrative operations snapshot used by the hero panel. These are
// representative figures for the marketing site, not live telemetry.

